<template>
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.8042 0.661663C15.3395 0.206663 14.5889 0.206663 14.1242 0.661663L8.29783 6.355L2.47144 0.649996C2.00676 0.194996 1.25612 0.194996 0.791443 0.649996C0.326762 1.105 0.326762 1.84 0.791443 2.295L6.61783 8L0.791443 13.705C0.326762 14.16 0.326762 14.895 0.791443 15.35C1.25612 15.805 2.00676 15.805 2.47144 15.35L8.29783 9.645L14.1242 15.35C14.5889 15.805 15.3395 15.805 15.8042 15.35C16.2689 14.895 16.2689 14.16 15.8042 13.705L9.97783 8L15.8042 2.295C16.257 1.85166 16.257 1.105 15.8042 0.661663V0.661663Z"
            fill="#B8CDD7" />
    </svg>

</template>

<script>
    export default {

    }
</script>

<style lang="scss" scoped> 
    svg {
        path {
            transition: all 0.2s ease;
        }
        &:hover {
            path {
                fill: #8DA0A9;
            }
        }
    }
</style>